export default __webpack_public_path__ + "static/media/icon_info_category_06.c5b16504.svg";